module.exports = __webpack_public_path__ + "static/img/collaboration.b7445dc.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/collaboration.jpeg
// module id = TUDg
// module chunks = 7